export default __webpack_public_path__ + "static/media/EM1460.34I-37468_-22087_0.9725d65b.jpg";